import React from "react";
import { LOGIN_SIDE_MODULES } from "../../utility/constants/authUi";
import { TickIcon } from "./icons";
import LoginSidePanelArt from "./LoginSidePanelArt";

const LoginSidePanel = () => (
  <aside className="login-side">
    <LoginSidePanelArt />
    <p className="login-side-h">Everything your legal team runs on, in one place.</p>
    <div className="login-mods">
      {LOGIN_SIDE_MODULES.map((mod) => (
        <div key={mod.id} id={mod.id} className="login-mod">
          <span className="login-mod-tick">
            <TickIcon />
          </span>
          {mod.label}
        </div>
      ))}
    </div>
  </aside>
);

export default LoginSidePanel;
